if (!process.env.REACT_APP_API) {
  throw new Error(
    "API configuration missing: REACT_APP_API is required"
  )
}

export const BASE_API_URL = `${process.env.REACT_APP_API}/api/v1`

if (!process.env.REACT_APP_CLIENT_ID) {
  throw new Error(
    "Google configuration missing: REACT_APP_CLIENT_ID is required"
  )
}

export const GOOGLE_CLIENT_ID = process.env.REACT_APP_CLIENT_ID

if (!process.env.REACT_APP_APPLE_CLIENT_ID) {
  throw new Error(
    "Apple configuration missing: REACT_APP_APPLE_CLIENT_ID is required"
  )
}

export const APPLE_CLIENT_ID = process.env.REACT_APP_APPLE_CLIENT_ID
